/**************************************************
 * Nombre:       Pagina
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Barra from "./Barra/Barra";
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import {useEffect} from "react";
import {irArriba} from "../Utilidades/irArriba";
import Seccion_Home from "./Secciones/Seccion_Home";
import Footer from "./Footer";
import Seccion_Detalle from "./Secciones/Seccion_Detalle";
import Seccion_Profesional from "./Secciones/Seccion_Profesional";
import Seccion_Blog from "./Secciones/Seccion_Blog";

const Pagina = () => {


    useEffect(() => {
        irArriba()
    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: '#fdf3e9'}}
        >


            <Router>
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 2}}>
                    <Barra/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 1}}>
                    <Routes>
                        <Route path={"*"} element={<Seccion_Home/>}/>
                        <Route path={"/Home"} element={<Seccion_Home/>}/>
                        <Route path={"/Detalle"} element={<Seccion_Detalle/>}/>
                        <Route path={"/Profesional/:id"} element={<Seccion_Profesional/>}/>
                        <Route path={"/Blog/:id"} element={<Seccion_Blog/>}/>
                    </Routes>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: 'flex-start', mt: 8, overflow: 'hidden'}}>
                    <Footer/>
                </Grid>

            </Router>

        </Grid>
    )

}
export default Pagina